<script>
  import { fade } from "svelte/transition";
  import { onMount } from "svelte";

  import { currentProgress, scrollDirection } from "../stores/scrollVars.js";
  import mq from "../stores/mq.js"; // here, defined laptop = 992px

  export let annotationsList = [];
  export let annotatePos;
  export let colour = "neutral";
  export let startOn = 0.05;
  
  $: threshold = {lower: startOn, upper: 0.5}; // $mq.mobile ? 0.2 : 0.5;
  $: isActive = $currentProgress > threshold.lower && $currentProgress < 0.95;

  $: annotationProgress = ($currentProgress - threshold.lower) / (threshold.upper - threshold.lower)

</script>

{#if annotationsList.length > 0 && !($mq.mobile || $mq.shortDesktop)}
  <div class="scene-annotations {$mq.classNames}" out:fade={{ duration: 500 }}>
    {#each annotationsList as a, j (a.value)}
        <div
          class="text-abs {colour}"
          class:active={annotationProgress * annotationsList.length >= j && isActive}
          in:fade={{ duration: $scrollDirection == "up" ? 500 : 200 }}
          out:fade={{ duration: 500 }}
          style="left:{annotatePos[a.type].left}; top: {annotatePos[a.type].top}; right: 2%; max-width: {annotatePos[
            a.type
          ].width};"
        >
          {a.value}
        </div>
    {/each}
  </div>
{/if}

<style>
  .scene-annotations {
    font-size: var(--voila-annotations-font-size);
  }
  
  .text-abs {
    position: absolute;
    z-index: var(--z-top);
    background-color: hsla(var(--purple-dark_hsl), 0.8);
    color: var(--voila-text-annotations);
    padding: 15px;
    border-radius: 15px;
    width: 13em;
    opacity: 0;
    transition: opacity 1s;
  }
  
  .text-abs.active {
    opacity: 1;
  }

  .text-abs.negative {
    background-color: var(--voila-negative-annotation);
    /* color: var(--off-black); */
  }

  .text-abs.positive {
    background-color: var(--voila-positive-annotation);
  }
</style>
